<template>
  <v-card tile v-if="invitation">
    <v-toolbar card dark color="primary">
      <v-btn icon @click.native='close' dark>
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Edit Package</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click.native="save">Save</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text>
      <v-form v-if="formData">
        <v-layout row justify-space-around>
          <v-card></v-card>
          <v-flex ma-3>
            <v-card ma-2 class="elevation-4">
              <v-flex pa-3>
                <v-layout row wrap>
                  <v-flex xs6>
                    <content-field
                      v-model="formData.name"
                      label="Name"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs6>
                    <content-field
                      v-model="formData.title"
                      label="Title"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs6>
                    <content-field
                      v-model="formData.messagesLimit"
                      label="Messages limit"
                      :error="$v.formData.messagesLimit"
                      type="number"
                    />
                  </v-flex>
                </v-layout>
                <v-checkbox
                  v-model="formData.shouldUpdateRegistered"
                  label="Should update registered"
                />
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-select
                      v-model="formData.confirmationEmailTemplateName"
                      :items="registrationSuccesTemplatesList"
                      item-text="templateKey"
                      item-value="templateKey"
                      label="Confirmation email template"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-select
                      v-model="formData.failedPaymentEmailTemplateName"
                      :items="registrationFailtureTemplatesList"
                      item-text="templateKey"
                      item-value="templateKey"
                      label="Failed payment email tempalte"
                    />
                  </v-flex>
                </v-layout>

                <a-package-price-counter
                  v-if="formData.price"
                  :defaultPrice="formData.price"
                  :discountInCurrency="invitationData.discountInCurrency"
                  :discountInPercent="invitationData.discountInPercent"
                />

                <v-flex ma-3 v-if="arePredefinedActivitiesExist">
                  <h3>Predefined activities </h3>
                  <v-layout row wrap>
                    <v-flex xs12 class="my-4">
                      <div v-for="(value) in predefinedActivity"
                        :key="`predefined-activity-${value.id}`">
                        <v-checkbox
                          v-model="formData.predefinedActivities"
                          :label="`${value.title}`"
                          :value="value.id"
                        />
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-flex>
            </v-card>
          </v-flex>
        </v-layout>
      </v-form>

    </v-card-text>
  </v-card>
</template>

<script>
import ContentField from '@/components/shared/ContentField'
import APackagePriceCounter from '@/components/shared/APackagePriceCounter'
// import ContentEditor from '@/components/shared/ContentEditor'
import { mapGetters, mapActions } from 'vuex'
import { required, minValue, numeric } from 'vuelidate/lib/validators'
import { clone, path, pathOr} from 'ramda'
import mixins from '@/utils/mixins'

export default {
  name: 'EditInvitationPackageForm',
  mixins: [mixins.emailTemplates],
  components: {
    ContentField,
    APackagePriceCounter
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    invitation: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      formData: {},
      invitationData: {}
    }
  },
  watch: {
    item: {
      handler (val) {
        this.formData = clone(val)
      },
      immediate : true,
      deep: true
    },
    invitation: {
      handler (val) {
        if (val) {
          this.invitationData = clone(this.invitation)
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'predefinedActivity',
      'getSettings'
    ]),
    arePredefinedActivitiesExist () {
      return this.predefinedActivity.length
    }
  },
  validations: {
    formData: {
      id: { required },
      messagesLimit: { numeric, minValue: minValue(0) },
      price: { numeric, minValue: minValue(0) }
    }
  },
  methods: {
    ...mapActions([
      'getPredefinedActivity',
      'updateVipInvitationPackage'
    ]),
    clearModalData() {
      this.formData = {}
      this.invitationData = {}
    },
    async save () {
      this.$v.$touch()
      if (this.$v.formData.$invalid) return
      await this.updateVipInvitationPackage(this.formData)
      this.close()
    },
    close () {
      this.clearModalData()
      this.$emit('close')
    }
  },
  created () {
    this.getPredefinedActivity()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Registration/Attendee/VipInvitation/editInvitationPackageForm.vue